<template>
  <div>
    <!-- Start Header Area -->
    <Header>
      <img slot="logo" :src="logo" />
    </Header>
    <!-- End Header Area -->
    <!-- Start 404 Page  -->
    <div class="error-page-inner bg_color--4">
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="inner">
              <h1 class="heading-title theme-gradient">404!</h1>
              <h3 class="sub-title">Página não encontrada</h3>
              <span>A página que você estava procurando não foi encontrada.</span>
              <div class="error-button">
                <router-link class="btn-default" to="/"
                  >Página Inicial</router-link
                >
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End 404 Page  -->
    <Footer />
  </div>
</template>

<script>
  import Header from "../components/header/Header";
  import FooterTwo from "../components/footer/FooterTwo";
  import Footer from "../components/footer/Footer";
  export default {
    components: {
      Header,
      FooterTwo,
      Footer
    },
    data() {
      return {
        logo: "/logoCodetimeWhite.webp",
      };
    },
  };
</script>
